/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctAnyType, FctString } from '../../../Fct/generics';
export var GetParam = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'getParam',
    name: 'getParam',
    flowType: 'OFFCHAIN_ONLY',
    getParams: function () { return ({
        input: {
            key: new FctString({}),
            param: new FctAnyType({ required: false, readonly: true }),
            methodParams: {},
        },
        output: {},
    }); },
});
